import './error-state.less';
import { noDataImage } from './no-data.svg';

const template=`
<widget-status></widget-status>
<generic-highchart chart-data="chartData" drill="drillDown()" ng-if="!showMwVisualization" ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></generic-highchart>
<mw-chart-grouped-column chart-data="mwGroupedChartData" ng-if="showMwVisualization && !showErrorState" ng-hide="widgetIsLoading" chart-options="mwGroupedColumnOptions" get-api="getMwApi(API)" on-error="onMwError(error)"></mw-chart-grouped-column>
<div ng-if="showErrorState && showMwVisualization" ng-hide="widgetIsLoading" class="widget-error-state__container">
    <img class="widget-error-state__inline-svg-min" src="${noDataImage}" />
    <span class="widget-error-state__title-text widget-error-state__title-text-min-view">Too many inputs</span>
    <span class="widget-error-state__subtitle-text widget-error-state__subtitle-text-min-view">Select a different chart type or reduce the number of inputs to five or fewer</span>
</div>`;
export default template;
